import { render, staticRenderFns } from "./jtjj.vue?vue&type=template&id=ac9e69a4&scoped=true"
import script from "./jtjj.vue?vue&type=script&lang=js"
export * from "./jtjj.vue?vue&type=script&lang=js"
import style0 from "./jtjj.vue?vue&type=style&index=0&id=ac9e69a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9e69a4",
  null
  
)

export default component.exports